import * as React from 'react';

import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import _startCase from 'lodash/startCase';

import { useFormUpdateProxy } from '../core/context/FormUpdateProxyContext';
import useEditableController from '../core/api/hooks/common/useEditableController';

import ReadOnlyField from './ReadOnlyField';
import EditableField from './EditableField';

interface IControlledCheckbox<TFieldValues extends FieldValues> extends UseControllerProps<TFieldValues> {
  label?: string;
  readOnly?: boolean;
  disableEditPopper?: boolean
  CheckboxProps?: CheckboxProps,
}

function ControlledCheckbox<TFieldValues extends FieldValues>({
  name,
  label,
  control,
  readOnly,
  disableEditPopper,
  CheckboxProps: checkboxProps,
}: IControlledCheckbox<TFieldValues>): JSX.Element {
  const { requestUpdate } = useFormUpdateProxy();
  const {
    field,
    revertChanges,
    commitChanges,
  } = useEditableController<TFieldValues>({
    name,
    control,
  });
  return (
    <EditableField
      fieldName={name}
      renderMode={readOnly ? 'read' : 'edit'}
      disableEditPopper={disableEditPopper}
      saveSuccess={() => {
        commitChanges();
        requestUpdate();
      }}
      onEditCancel={revertChanges}
      renderEditField={() => (
        <FormControlLabel
          label={label || _startCase(name) || ''}
          control={(
            <Checkbox
              {...checkboxProps}
              {...field}
              checked={field.value}
              value={checkboxProps?.value || ''}
            />
          )}
          onBlur={field.onBlur}
        />
      )}
      renderReadField={() => (
        <ReadOnlyField
          name={label || _startCase(name)}
          value={field.value === true ? 'Yes' : 'No'}
        />
      )}
    />
  );
}

export default ControlledCheckbox;
